export default "__VITE_ASSET__f389ff50__"